import { StyledTag } from '../layout/tag/tag.styles';
import { TagProps } from './tag-types'; 

export const Tag = (props: TagProps) => (
    <StyledTag color={props.color ? props.color : 'green'}>
        {props.children}
    </StyledTag>
);
